(function() {
  document.addEventListener('click', function(event) {
    var copyButton = event.target.closest && event.target.closest('.product-share__button-default');
    if (copyButton) {
      var url = copyButton.getAttribute('data-share-url');
      if (url && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function() {
          showFeedback(copyButton);
        }).catch(function(err) {
          console.error('Erro ao copiar: ', err);
        });
      }
      return;
    }

    var waButton = event.target.closest && event.target.closest('.product-share__button-whatsapp');
    if (waButton) {
      var productUrl = waButton.getAttribute('data-share-url');
      if (!productUrl) return;

      var template = waButton.getAttribute('data-whatsapp-message') || 'Mirá este producto: [url]';
      var text = template.indexOf('[url]') !== -1
        ? template.split('[url]').join(productUrl)
        : template + ' ' + productUrl;
      var message = encodeURIComponent(text);
      var waUrl = 'https://wa.me/?text=' + message;

      window.open(waUrl, '_blank');
    }
  });

  function showFeedback(button) {
    var container = button.closest('.product-share__button-wrapper') || button.parentElement;
    if (!container) return;

    var feedback = container.querySelector('.product-share-copy__feedback');

    if (!feedback) {
      feedback = document.createElement('span');
      feedback.className = 'product-share-copy__feedback';
      feedback.textContent = 'Copiado';
      container.appendChild(feedback);
    }

    feedback.classList.add('is-visible');

    window.setTimeout(function() {
      feedback.classList.remove('is-visible');
    }, 2000);
  }

  var shareMobileQuery = window.matchMedia('(max-width: 768.98px)');

  function findProductShareContainer(source, slot) {
    if (!source) return null;
    var container = source.querySelector('.product-share-container');
    if (!container && slot) {
      container = slot.querySelector('.product-share-container');
    }
    return container;
  }

  function relocateProductShare() {
    var slot = document.querySelector('[data-product-share-mobile-slot]');
    var source = document.querySelector('[data-product-share-source]');
    if (!source) return;

    var container = findProductShareContainer(source, slot);
    if (!container) return;

    if (shareMobileQuery.matches && slot) {
      if (container.parentElement !== slot) {
        slot.appendChild(container);
      }
      source.classList.add('is-share-relocated');
      return;
    }

    if (container.parentElement !== source) {
      source.appendChild(container);
    }
    source.classList.remove('is-share-relocated');
  }

  function initProductSharePlacement() {
    relocateProductShare();
    if (typeof shareMobileQuery.addEventListener === 'function') {
      shareMobileQuery.addEventListener('change', relocateProductShare);
    } else if (typeof shareMobileQuery.addListener === 'function') {
      shareMobileQuery.addListener(relocateProductShare);
    }
  }

  document.addEventListener('shopify:section:load', initProductSharePlacement);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSharePlacement);
  } else {
    initProductSharePlacement();
  }

  window.addEventListener('load', relocateProductShare);
})();
